<template>
    <v-card>
        <v-card-title>
            {{ $t('Ryhmät') }}
        </v-card-title>
        <v-card-text>
            <p>
                Yritys voi nyt itse luoda uusia ryhmiä Piiriin ja poistaa ryhmiä käytöstä merkitsemällä ne
                ei-aktiiviseksi. Ryhmien jäseniä hallitaan Käyttäjät-osiossa.
            </p>
            <v-btn color="primary" class="mb-4" @click="newGroup">
                <span>{{ $t("Uusi ryhmä") }}</span>
            </v-btn>

            <v-data-table :headers="headers" :items="groups" :server-items-length="totalGroups" :loading="loading">
                <template v-slot:item.name="{ item }">
                    <a @click="editGroup(item.id)">
                        {{ item.name }}
                    </a>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon v-if="item.is_active" size="24" color="success">{{ icons.mdiCheckboxMarkedCircle }}
                    </v-icon>
                    <v-icon v-else size="24" color="error">{{ icons.mdiCloseCircle }}
                    </v-icon>
                </template>
            </v-data-table>
            <v-dialog :key="editGroupId" v-model="formDialogVisible" max-width="720px" persistent>

                <v-card>
                    <div class="text-right pr-2 pt-2">
                        <v-icon class="text-right" size="32" @click="formDialogVisible = false">{{ icons.mdiCloseCircle
                            }}
                        </v-icon>
                    </div>
                    <v-card-text class="pt-6">
                        <groupForm :id="editGroupId" @saved="refresh"></groupForm>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiPlus } from "@mdi/js";
import groupForm from './components/group_form.vue';
import adminApi from "@/api/admin";
import useAuth from "@/useAuth";
import { i18n } from "@/plugins/i18n";

export default {
    components: {
        groupForm
    },
    setup() {
        const loading = ref(false);
        const groups = ref([]);
        const totalGroups = ref(0);
        const editGroupId = ref(null);
        const formDialogVisible = ref(false);
        const { tenant } = useAuth();

        const fetchGroups = async () => {
            loading.value = true
            const response = await adminApi.getGroups()
            if (response.ok) {
                groups.value = response.data;
                totalGroups.value = response.data.length;
            }
            else {
                alert(response.error);
            }
            loading.value = false;
        }

        const editGroup = (id) => {
            editGroupId.value = id;
            formDialogVisible.value = true;
        }

        const newGroup = async () => {
            editGroupId.value = null;
            formDialogVisible.value = true;
        }

        const refresh = async (id) => {
            window.location.href = window.location.href;
        }

        onMounted(() => {
            fetchGroups()
        });

        const headers = ref([
            {
                text: i18n.t('Nimi'),
                value: 'name',
            },
            {
                text: i18n.t('Aktiivinen'),
                value: 'is_active',
            },
        ]);

        return {
            loading,
            groups,
            totalGroups,
            editGroup,
            editGroupId,
            formDialogVisible,
            refresh,
            newGroup,
            headers,
            tenant,
            icons: {
                mdiCheckboxMarkedCircle,
                mdiCloseCircle,
                mdiPlus,
            },
        }
    }

}
</script>

<style scoped>
.v-data-table {
    width: 100%;
}
</style>
